import { Text } from '@chakra-ui/react';
import React from 'react';

const LoadingComponent: React.FC = () => {
  return (
    <>
      <Text color={'propulsion.thirdy'}>Loading</Text>
    </>
  );
};

export default LoadingComponent;
